module.exports = __webpack_public_path__ + "static/media/6 Servatius-Schatzkammer-bearb.a31ef18b.jpg";